import {POLTRONA_GRATUITA_DISPONIVEL } from '../../actions/types';

const initialState = null

export default function reducerQuantidadeGratuidade (state = initialState, action ) {
  switch (action.type) {
    case POLTRONA_GRATUITA_DISPONIVEL: {
      return action.payload.data
    }

    default:
      return state
  }
}
